import ApiBase from './base/ApiBase'
import { TemplateGraph, TemplateRevision2ProficiencyGroup } from '../models/dtos';
import { NameIdSlim, ApiResponseContent } from '../models/custom-models';

class TemplateClient extends ApiBase {
    private controllerName: string = 'Template/Revision';

    async Create(sourceRevId: string, signal?: AbortSignal): Promise<string>{
        return this.PostAsync(`${this.controllerName}?sourceRevisionId=${sourceRevId}`, signal);
    }

    async GetAll(id: string, signal?: AbortSignal): Promise<ApiResponseContent<NameIdSlim[]>>{
        return this.GetAsync(`${this.controllerName}/${id}/Profiles`, signal);
    }

    async GetGraph(id: string, signal?: AbortSignal): Promise<ApiResponseContent<TemplateGraph>> {
        return this.GetAsync(`${this.controllerName}/${id}/Graph`, signal);
    }

    async GetWeights(id: string, signal?: AbortSignal): Promise<TemplateRevision2ProficiencyGroup[]> {
        return this.GetAsync(`${this.controllerName}/${id}/Weights`, signal);
    }

    async UpdateWeight(id: string, dto: TemplateRevision2ProficiencyGroup, signal?: AbortSignal) {
        return this.PutAsync(`${this.controllerName}/${id}/Weight`, dto, signal);
    }
}

export enum TemplateRevisionErrors {
    Create = 'Error creating template revision',
    GetSingle = 'Error loading template revision',

    UpdateWeight = 'Error updating weight'
}

export default TemplateClient;